const styles = {
  ulContainer: {
    padding: 0,
    marginBottom: 0,
  },
}

export default styles
